import { useTheme } from '@mui/material/styles';
/** Component */
import {
  Box,
  Grid,
  Container,
  Typography,
  Paper,
  Divider,
} from "@mui/material";
import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import { useParams } from "react-router-dom";
import { useEffect, useState, } from 'react';
import { AdminApi } from "../../api/AdminApi";
import MemberImportForm from "../../components/app/member/MemberImportForm/MemberImportForm";


// Testing URL 
// http://localhost:3000/organization/2/member/import
// ----------------------------------------------------------------------

export default function Component() {
  const theme = useTheme();

  let { orgId } = useParams();

  const [orgData, setOrgData] = useState({});

  // let organizationName = "??";

  useEffect(() => {

    AdminApi.getOrgnizationDetailCallback(orgId, (isSuccess, msg, data) => {
      console.debug("result: isSuccess=", isSuccess, " msg=", msg, " data=", data);
      if (isSuccess) {
        setOrgData(data.record);
      } else {
        console.log("Data not found with id - " + orgId);
      }
    });
    // getDataRequest(`organization/show/${orgId}`, (isSuccess, data) => {
    //   if (!isSuccess) {
    //     console.log("Data not found with id - " + orgId);
    //   }
    //   let { record } = data;

    //   setOrgData(record);
    // });
  }, []);


  // url: http://localhost:3000/organization/2/member/import

  return (
    <Container maxWidth={"lg"}>
      {/* Backdrop */}
      {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isDataPadding}
      > */}
      {/* <CircularProgress color="inherit" /> */}
      {/* </Backdrop> */}
      {/* <CommonBreadcrumb
        dbData={{ ...currentRecordData, organization_name: orgData?.name_zh }}
      /> */}
      <CommonBreadcrumb dbData={{ organization_id: orgId, organization_name: orgData.name_zh }} />
      <Grid container columnSpacing={2}>
        <Grid item xs={12}>
          <Box component="form" sx={{ mt: 3 }}>
            <Paper sx={{ px: 3, py: 1 }} elevation={3}>
              <Typography variant="h4" sx={{ mb: 1 }}>
                {orgId}
                : {orgData ? orgData.name_zh : ""}
                {/* TODO: Member Import form {orgId} */}
                {/* {JSON.stringify(orgData)} */}
              </Typography>
            </Paper>


            {
              orgData &&
              <MemberImportForm defaultOrg={orgData} canSelectOrg={false} />
            }

          </Box>

          <Divider sx={{ mt: 3 }} />
          <Typography variant="body2" sx={{ mt: 2 }}>
            學生CSV檔案模板：
            <li><a href="https://docs.google.com/spreadsheets/d/1I2yNykPdO9VUaTA_RYt-asfmbQhVMOKizmOr08WhvRU/edit?usp=sharing" download>Google Sheet連結 </a></li>
            <li><a href="https://drive.google.com/file/d/1tPOertoK_Nsq8yhXkt68nTDhZBQOIbC9/view?usp=sharing" download>CSV 檔下載 </a></li>
          </Typography>

        </Grid>
      </Grid>
    </Container>
  );
}
